"use strict";
/**
 * Main entry point.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Api = require("./src/Api/Api");
exports.Api = Api;
var FloodgateEngine_1 = require("./src/FloodgateEngine");
exports.FloodgateEngine = FloodgateEngine_1.FloodgateEngine;
